
  import { defineComponent } from 'vue';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { Button } from '@/ui/components/Button';

  export default defineComponent({
    name: 'SystemRejectedButton',
    components: { Tooltip, Button },
    props: {
      reason: {
        type: String,
        default: null,
      },
      cssClass: {
        type: String,
        default: '',
      },
    },
  });
